import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { BrandLogo, PrimaryButton } from "@ocs/ui";
import { LockKeyhole } from "lucide-react";
import { adminApi } from "../api";

type LoginForm = { username: string; password: string };

export function LoginPage() {
  const navigate = useNavigate();
  const form = useForm<LoginForm>({ defaultValues: { username: "", password: "" } });
  const login = useMutation({
    mutationFn: (values: LoginForm) => adminApi<{ username: string }>("/auth/login", {
      method: "POST",
      body: JSON.stringify(values)
    }),
    onSuccess: () => navigate("/")
  });
  return (
    <main className="login-page">
      <section className="login-brand">
        <BrandLogo />
        <p className="eyebrow">OPERATIONS CONSOLE</p>
        <h1>链上资金，<br />逐笔可核。</h1>
        <p>面向节点业务的只读运营、对账与结算计算平台。</p>
      </section>
      <form className="login-form" onSubmit={form.handleSubmit((values) => login.mutate(values))}>
        <div className="login-form__heading"><LockKeyhole /><div><h2>管理员登录</h2><p>仅限唯一授权管理员</p></div></div>
        <label>用户名<input autoComplete="username" {...form.register("username", { required: true })} /></label>
        <label>密码<input type="password" autoComplete="current-password" {...form.register("password", { required: true, minLength: 10 })} /></label>
        {login.error && <p className="form-error" role="alert">{login.error.message}</p>}
        <PrimaryButton disabled={login.isPending}>{login.isPending ? "验证中…" : "安全登录"}</PrimaryButton>
        <small>连续失败 5 次将锁定 15 分钟。系统不保存任何合约 Owner 或多签私钥。</small>
      </form>
    </main>
  );
}
